import(/* webpackMode: "eager" */ "/home/developer/www/bazz.bet/bzfront/src/app/[locale]/not-found.tsx");
